import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { Tabs, Tab } from "../../components/Tab";

const ServicePosPage = () => {
  const [isVisible, setIsVisible] = useState<boolean[]>([false]);

  // text 애니메이션
  const hideRefs = [
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;

      hideRefs.forEach((ref, index) => {
        const element = ref.current;
        if (element) {
          const elementTop = element.offsetTop;
          const elementHeight = element.offsetHeight;
          const isElementVisible =
            scrollTop + windowHeight > elementTop &&
            scrollTop < elementTop + elementHeight;
          setIsVisible((prev) => {
            const newVisible = [...prev];
            newVisible[index] = isElementVisible;
            return newVisible;
          });
        }
      });

      if (scrollTop + windowHeight === documentHeight) {
        setIsVisible((prev) => {
          const newVisible = [...prev];
          newVisible[newVisible.length - 1] = true;
          return newVisible;
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <Style>
      <div className="wrap">
        <div className="bannerTitle mobileView">
          <h1
            ref={hideRefs[5]}
            className={` ${isVisible[5] ? "in_view fade_in" : "fade_in"}`}
          >
            POS
          </h1>
          <h2>바쁜 테이크아웃 매장부터 전문 다이닝까지</h2>
        </div>
        <div className="banner">
          <img
            src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webPosImage01.png"
            alt="바쁜 테이크아웃 매장부터 전문 다이닝까지 사용가능한 비하인드 포스"
            className="webPos01"
          />
          <img
            src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webPosImage01-pos.png"
            alt="비하인드 포스"
            className="behindPos webView"
          />
        </div>
        <div className="contentWrap">
          <div className="content">
            <h1
              ref={hideRefs[0]}
              className={` ${isVisible[0] ? "in_view fade_up" : "fade_up"}`}
            >
              알림톡 전송
            </h1>
            <h2>
              주문 완료, 음식 준비 완료시
              <br />
              알림톡으로 고객을 호출할 수 있습니다.
            </h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webPosImage02.png"
              alt="주문완료, 음식 준비 완료 시 알림톡으로 고객 호출 가능한 포스"
              className="webPos02"
            />
          </div>
          <div className="content">
            <h1
              ref={hideRefs[1]}
              className={` ${isVisible[1] ? "in_view fade_up" : "fade_up"}`}
            >
              실시간 상품 수정 가능
            </h1>
            <h2>
              포스뿐만 아니라 휴대폰으로도
              <br />
              원하실 때 언제든 상품정보를 바꿔보세요.
            </h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webPosImage03.png"
              alt="포스에서도 휴대폰에서도 상품정보를 수정할 수 있는 포스"
              className="webPos03"
            />
          </div>
          <div className="content">
            <h1
              ref={hideRefs[2]}
              className={` ${isVisible[2] ? "in_view fade_up" : "fade_up"}`}
            >
              매출 관리
            </h1>
            <h2>상품별 매출을 한눈에 확인할 수 있습니다.</h2>
            <div className="subTabWrap">
              <Tabs>
                <Tab label="상품별 매출">
                  <img
                    src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webPosImage04-1.png"
                    alt="상품별 매출확인 가능한 포스"
                    className="webPos04"
                  />
                </Tab>
                <Tab label="매출달력">
                  <img
                    src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webPosImage04-2.png"
                    alt="매출달력확인 가능한 포스"
                    className="webPos04"
                  />
                </Tab>
                <Tab label="당일 매출">
                  <img
                    src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webPosImage04-4.png"
                    alt="당일 매출 확인 가능한 포스"
                    className="webPos04"
                  />
                </Tab>
                <Tab label="분류별 매출">
                  <img
                    src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webPosImage04-3.png"
                    alt="분류별 매출 확인 가능한 포스"
                    className="webPos04"
                  />
                </Tab>
              </Tabs>
            </div>
          </div>
          <div className="content">
            <h1
              ref={hideRefs[3]}
              className={` ${isVisible[3] ? "in_view fade_up" : "fade_up"}`}
            >
              단골이 늘어나는 고객 마케팅
            </h1>
            <h2>
              매장에 이벤트가 있거나 고객이 포인트를 적립하면
              <br />
              카카오톡 알림톡이 발송됩니다.
            </h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webPosImage05.png"
              alt="고객마케팅이 가능해 단골을 사로잡을 수 있는 포스"
              className="webPos05"
            />
          </div>
        </div>
        <div className="footerContent">
          <h4>안드로이드 포스가 없으신가요?</h4>
          <h3
            ref={hideRefs[4]}
            className={` ${isVisible[4] ? "in_view fade_in" : "fade_in"}`}
          >
            지금 바로 구매하세요!
          </h3>
          <button>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webPosImage06.png"
              alt="비하인드 포스 바로 구매해보세요"
              className="webPos06"
            />
          </button>
        </div>
      </div>
    </Style>
  );
};

export default ServicePosPage;
const Style = styled.div`
  h1,
  h2,
  h3,
  h4 {
    text-align: center;
  }
  h1 {
    font-size: 36px;
    font-weight: 700;
    line-height: 50px;
    color: #333;
  }
  h2 {
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    color: #979797;
  }
  h3 {
    font-size: 68px;
    font-weight: 700;
    line-height: 95px;
  }
  h4 {
    font-size: 36px;
    font-weight: 500;
    color: #979797;
    line-height: 50px;
  }
  .wrap {
    width: 100%;
    max-width: 100%;
    margin-top: 100px;

    img {
      width: 100%;
    }
  }

  .banner {
    width: 100%;
    position: relative;

    .behindPos {
      width: 41%;
      max-width: 769px;
      position: absolute;
      top: 8%;
      right: 14%;
    }
  }
  .contentWrap {
    width: 100%;
    padding: 60px 30%;

    .content {
      padding: 160px 0;

      h1 {
        margin-bottom: 32px;
      }
      img {
        margin-top: 50px;
      }
    }
  }

  .footerContent {
    text-align: center;
    h3 {
      display: inline-flex;
      padding: 20px 0 60px 0;
      background: linear-gradient(90deg, #4dd2ae 0%, #5096ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    }
    h4 {
      margin-top: 60px;
    }
  }

  @media (max-width: 1100px) {
    h1 {
      font-size: 28px;
      font-weight: 700;
    }
    h2 {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }
    h3 {
      font-size: 32px;
      line-height: 44px;
    }
    h4 {
      font-size: 18px;
      line-height: 25px;
    }
    .wrap {
      margin-top: 70px;
    }
    .bannerTitle {
      h1 {
        font-size: 70px;
        line-height: 48px;
      }
      h2 {
        margin: 30px 0 40px 0;
        font-size: 16px;
        line-height: 25px;
      }
    }
    .contentWrap {
      padding: 40px 5vw;

      .content {
        padding: 40px 0;

        h1 {
          margin-bottom: 12px;
        }
        img {
          margin-top: 30px;
        }
      }
    }
    .footerContent {
      h3 {
        padding: 7px 5vw 30px 5vw;
      }
      h4 {
        margin-top: 0;
      }
    }

    /* 이미지 변경 */
    .webPos01 {
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobilePosImage01.png");
    }
    .webPos05 {
      padding: 5vw;
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobileKdsImage02.png");
    }
    .webPos06 {
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobilePosImage02.png");
    }
  }
`;
